import React from "react";

// Genera ["00:00", "00:15", ..., "23:45"] — las únicas opciones posibles.
const TIME_OPTIONS = [];
for (let h = 0; h < 24; h++) {
  for (const m of [0, 15, 30, 45]) {
    TIME_OPTIONS.push(`${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`);
  }
}

function openPicker(e) {
  // showPicker() abre el calendario nativo al pulsar en cualquier punto de la caja,
  // no solo en el icono. No soportado en Safari/iOS antiguos: falla en silencio y
  // el usuario sigue pudiendo abrirlo tocando el icono, como hoy.
  try { e.currentTarget.showPicker && e.currentTarget.showPicker(); } catch (_) {}
}

/**
 * Sustituto de <input type="datetime-local"> que fuerza los minutos a 00/15/30/45,
 * mostrando SOLO esas opciones en el desplegable de hora (no depende del navegador).
 *
 * value / onChange usan el mismo formato que datetime-local: "YYYY-MM-DDTHH:mm".
 * min acepta el mismo formato y solo restringe la parte de fecha.
 * placeholder: texto mostrado dentro de la caja de fecha cuando está vacía
 * (ej. "Fecha recogida"), en vez del "dd/mm/aaaa" del navegador.
 */
export default function DateTimeQuarterInput({
  value, onChange, min, required, className = "pc-input text-black",
  dateTestId, timeTestId, defaultTime = "10:00", placeholder,
}) {
  const [datePart, timePart] = (value || "").split("T");
  const minDate = min ? min.split("T")[0] : undefined;

  const handleDateChange = (e) => {
    const d = e.target.value;
    onChange(d ? `${d}T${timePart || defaultTime}` : "");
  };

  const handleTimeChange = (e) => {
    if (!datePart) return;
    onChange(`${datePart}T${e.target.value}`);
  };

  return (
    <div className="flex gap-2 min-w-0">
      <div className="relative flex-1 min-w-0" onClick={openPicker}>
        <input
          type="date"
          required={required}
          className={`${className} w-full min-w-0 cursor-pointer ${!datePart ? "text-transparent" : ""}`}
          value={datePart || ""}
          min={minDate}
          onChange={handleDateChange}
          onClick={openPicker}
          data-testid={dateTestId}
        />
        {!datePart && placeholder && (
          <span className="pointer-events-none absolute inset-y-0 left-3 flex items-center text-sm text-neutral-500 truncate">
            {placeholder}
          </span>
        )}
      </div>
      <select
        required={required}
        className={`${className} shrink-0`}
        style={{ width: "88px", padding: "10px 6px" }}
        value={timePart || ""}
        onChange={handleTimeChange}
        data-testid={timeTestId}
      >
        <option value="" disabled>--:--</option>
        {TIME_OPTIONS.map(t => <option key={t} value={t}>{t}</option>)}
      </select>
    </div>
  );
}
